<template>
  <v-footer absolute
    color="primary lighten-1"
  >
    <v-layout
      justify-center
      row
      wrap
    >
      <v-btn
        v-for="link in links"
        :key="link"
        color="white"
        flat
        round
      >
        {{ link }}
      </v-btn>
    </v-layout>
  </v-footer>      
</template>
    
<script>
export default {
    data: () => ({
      links: [
        ''
      ]
    })
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue